import jQuery from 'jquery';
let $ = jQuery;

import "HSNDIR/Service.js";

HSN.Service.ArcadeService = function () {

};

HSN.Service.ArcadeService.prototype =
{
    /*Cms Widget Helpers*/
    GetGamePlayWidget: function(data, config) {
        this._sendHtml("/widget/arcade/gameplay", data, config);
    },
        
    GetGameOverWidget: function(data, config) {
        this._sendHtml("/widget/arcade/gameover", data, config);
    },

    GetLeaderboardWidget: function (data, config) {
        this._sendHtml("/widget/arcade/leaderboard", data, config);
    },

    GetGameSize: function (ratio, container) {
        var result = { width : 0, height : 0 };
        var maxWidth = $(container).closest('.cms-cell').width();
        var maxHeight = $(window).height();

        if($(window).width() < maxWidth) {
            maxWidth = $(window).width();
        }

        if(maxWidth / ratio > maxHeight) {
            result.width = Math.round(maxHeight * ratio);
            result.height = maxHeight;
        }
        else {
            result.width = maxWidth;
            result.height = Math.round(maxWidth / ratio);
        }

        return result;
    },

    /*End Cms Widget Helpers*/

    GetTicketBalance: function(config) {
        this._send("/arcade/getticketbalance", {}, config);
    },

    RateGame: function (gameId, rating, config) {
        this._send("/arcade/rategame/", { GameId: gameId, Rating: rating }, config);
    },

    FavoriteGame: function (gameId, add, config) {
        this._send("/arcade/favoritegame", { GameId: gameId, Add: add }, config);
    },

    /* Rewards Services */
    GetLiveGridPage: function(page, config) {
        this._sendHtml("rewards/livegrid", {pageNumber: page}, config);
    },

    _send: function (url, data, config) {
        config = (config || {});

        var arcadeObjectName = HSN.GetHsnArcadeObjectName();
        if(arcadeObjectName !== null) {
            var fullyQualifiedUrl = config.baseUrl + url;

            var successCallback = function(data) {
                if(config.callback)
                    config.callback.call((config.scope || config.callback), data);
            };

            var failureCallback = function(xhr, status, error) {
                if(config.callback)
                    config.callback.call((config.scope || config.callback), true);
            }
                
            window[arcadeObjectName].easyXDM.rpc.ajaxRequest({
                url: fullyQualifiedUrl,
                type: 'POST',
                dataType: 'json', 
                data: data
            }, successCallback, failureCallback);
        }
        else {
            data['_ts'] = new Date().getTime();

            $.ajax(
                url,
                {
                    type : 'POST',
                    data : data,
                    context : this,
                    dataType : 'json',
                    success : function(data, status, xhr) {
                        if(config.callback)
                            config.callback.call((config.scope || config.callback), data);
                    },
                    error : function(xhr, status, error) {
                        if(config.callback)
                            config.callback.call((config.scope || config.callback), true);
                    }
                }
            );
        }
    },
        
    _sendHtml: function (url, data, config) {
        config = (config = config || {});

        var arcadeObjectName = HSN.GetHsnArcadeObjectName();
        if(arcadeObjectName !== null) {
            var fullyQualifiedUrl = config.baseUrl + url;

            var successCallback = function(data) {
                if(config.callback)
                    config.callback.call((config.scope || config.callback), true, data);
            };

            var failureCallback = function(xhr, status, error) {
                if(config.callback)
                    config.callback.call((config.scope || config.callback), false, error);
            }
                
            window[arcadeObjectName].easyXDM.rpc.ajaxRequest({
                url: fullyQualifiedUrl,
                type: 'GET',
                dataType: 'html', 
                data: data
            }, successCallback, failureCallback);
        }
        else {
            data['_ts'] = new Date().getTime();

            $.ajax(
                url,
                {
                    cache : (config.cacheable = config.cacheable || false),
                    type : 'GET',
                    data : data,
                    context : this,
                    dataType : 'html',
                    success : function(data, status, xhr) {
                        if(config.callback)
                            config.callback.call((config.scope || config.callback), true, data);
                    },
                    error : function(xhr, status, error) {
                        if(config.callback)
                            config.callback.call((config.scope || config.callback), false, error);
                    }
                }
            );
        }
    },
};



// WEBPACK FOOTER //
// ./assets/js/HSN/Service/ArcadeService.js